import styled from 'styled-components';

export const Wrapper = styled.div`
    .carousel__container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .carousel__alice-wrapper {
        min-width: 17rem;
        text-align: center;
        margin: 10px;
    }
    .mobile-card {
        cursor: pointer;
        height: 8rem;
        width: 16rem;
        margin: 1rem;
        border-radius: 15px;
    }
`;

export default Wrapper;